import { Injectable, signal } from '@angular/core'

/**
 * Oeffnet das Support-Sheet von einer beliebigen Stelle der App aus, optional gleich mit einer Frage.
 *
 * **Warum ein eigener, leerer Dienst und nicht der `AssistentService`:** das Sheet und seine Vorlagen
 * liegen in `leistungserbringer-navigation`, die Anfrage kommt aber auch aus Dialogen und Karten
 * (`app-support-card` mit `[fragen]="true"`). Der `AssistentService` laedt beim ersten Zugriff den
 * Gespraechsverlauf; ihn in der Navigation oder in jeder Support-Karte zu injizieren, haette diese
 * Abfrage bei jedem Seitenaufruf ausgeloest, auch auf dem Boot-Fehler-Bildschirm. Dieser Dienst traegt
 * nur die Bitte, das Sheet reagiert darauf.
 */
@Injectable({
  providedIn: 'root',
})
export class SupportSheetService {
  /**
   * Zaehlt jede Bitte, das Sheet zu oeffnen. Ein Zaehler statt eines Schalters, damit dieselbe Bitte
   * zweimal hintereinander wirkt, auch wenn das Sheet dazwischen geschlossen wurde.
   */
  readonly angefragt = signal(0)

  /** Die Frage, die das Sheet beim naechsten Oeffnen stellt. Das Panel liest sie und leert sie wieder. */
  readonly offeneFrage = signal<string | undefined>(undefined)

  /**
   * Ob gerade eine Oberflaeche das Sheet traegt. Es haengt in der Leistungserbringer-Navigation;
   * externe Partner und der Boot-Bildschirm haben keins. Ein Knopf, der hierher fragt, erscheint nur,
   * wenn das stimmt: sonst taete er sichtbar nichts (Grund-Karte der Versorgung, Fehlerdialog).
   */
  readonly verfuegbar = signal(false)

  oeffnen(frage?: string): void {
    const text = frage?.trim()
    if (text) {
      this.offeneFrage.set(text)
    }
    this.angefragt.update((n) => n + 1)
  }
}
